<template>
    <div class="content">
        <div class="select_brush">
            <div>
                <p>描画モード</p>
                <div class="type">
                    <button @click="setPaintMode(CONST.PAINT_MODE_BRUSH)" :class="{selected: paint_mode === CONST.PAINT_MODE_BRUSH}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20.146" height="20" viewBox="0 0 20.146 20"><g transform="translate(-870.086 -4015.32)"><path d="M1119.355,4429.439H1110V4428h9.355Z" transform="translate(-229.124 -394.119)"/><path d="M972.721,4022.688l-7.263-7.263a.36.36,0,0,0-.509,0l-8.379,8.379,7.772,7.772,8.379-8.379A.36.36,0,0,0,972.721,4022.688Z" transform="translate(-82.595)"/><path d="M874.894,4235.636l-4.321-4.321a1.664,1.664,0,0,1,0-2.353l2.385-2.385,7.772,7.772-1.287,1.287Z" transform="translate(0 -201.756)"/></g></svg>
                    </button>
                    <button @click="setPaintMode(CONST.PAINT_MODE_ERASER)" :class="{selected: paint_mode === CONST.PAINT_MODE_ERASER}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g transform="translate(-1040 -2383.993)"><path d="M1193.265,2386.736c-2.38,2.486-7.487,7.479-11.438,11.017a4.065,4.065,0,0,0-.752-1.042,4.433,4.433,0,0,0-1.1-.8c3.825-4.248,9.008-9.535,11.007-11.462a1.614,1.614,0,0,1,2.263.025h0A1.621,1.621,0,0,1,1193.265,2386.736Z" transform="translate(-133.716)"/><path d="M1040,2678.377c1.518-1.589.618-4.043,2.1-5.526a3,3,0,0,1,4.238,0,3.193,3.193,0,0,1-.163,4.393C1044.71,2678.71,1042.491,2679.986,1040,2678.377Z" transform="translate(0 -275.131)"/></g></svg>
                    </button>
                </div>
            </div>
            <div>
                <p>ブラシ形状</p>
                <div class="size">
                    <button @click="setFreeHand(15)" class="free s" :class="{selected: paint_type === CONST.PAINT_FREE_HAND && brush_size === 15}">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             width="122.879px" height="122.879px" viewBox="0 0 122.879 122.879" enable-background="new 0 0 122.879 122.879"
                             xml:space="preserve"><g>
	<path d="M61.438,4.97c31.186,0,56.472,25.287,56.472,56.471c0,31.184-25.286,56.469-56.472,56.469
		c-31.182,0-56.468-25.285-56.468-56.469C4.97,30.256,30.256,4.97,61.438,4.97L61.438,4.97z"/></g>
</svg>
                    </button>
                    <button @click="setFreeHand(30)" class="free m" :class="{selected: paint_type === CONST.PAINT_FREE_HAND && brush_size === 30}">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             width="122.879px" height="122.879px" viewBox="0 0 122.879 122.879" enable-background="new 0 0 122.879 122.879"
                             xml:space="preserve"><g>
	<path d="M61.438,4.97c31.186,0,56.472,25.287,56.472,56.471c0,31.184-25.286,56.469-56.472,56.469
		c-31.182,0-56.468-25.285-56.468-56.469C4.97,30.256,30.256,4.97,61.438,4.97L61.438,4.97z"/></g>
</svg>
                    </button>
                    <button @click="setFreeHand(90)" class="free l" :class="{selected: paint_type === CONST.PAINT_FREE_HAND && brush_size === 90}">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             width="122.879px" height="122.879px" viewBox="0 0 122.879 122.879" enable-background="new 0 0 122.879 122.879"
                             xml:space="preserve"><g>
	<path d="M61.438,4.97c31.186,0,56.472,25.287,56.472,56.471c0,31.184-25.286,56.469-56.472,56.469
		c-31.182,0-56.468-25.285-56.468-56.469C4.97,30.256,30.256,4.97,61.438,4.97L61.438,4.97z"/></g>
</svg>
                    </button>
                    <button @click="setPaintType(CONST.PAINT_DRAW_SQUARE)" class="free l" :class="{selected: paint_type === CONST.PAINT_DRAW_SQUARE}">
                        <svg version="1.1" id="レイヤー_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                             y="0px" width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
                        <path d="M1.621,1.621v20.758h20.758V1.621"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="control">
            <div class="undo_redo">
                <div>
                    <button @click="undo">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12.132" height="9.052" viewBox="0 0 12.132 9.052">
                            <path class="a" d="M865.413,2894.1l4.762-2.165.007,1.289a7.648,7.648,0,0,1,7.362,7.632v.131h-1.556v-.131a6.153,6.153,0,0,0-5.8-6l0,1.314Z" transform="translate(-865.413 -2891.939)"/>
                        </svg>
                        戻す</button>
                    <button @click="redo">進む
                        <svg xmlns="http://www.w3.org/2000/svg" width="12.132" height="9.052" viewBox="0 0 12.132 9.052"><path class="a" d="M877.545,2894.1l-4.762-2.165-.007,1.289a7.648,7.648,0,0,0-7.363,7.632v.131h1.556v-.131a6.153,6.153,0,0,1,5.8-6l0,1.314Z" transform="translate(-865.413 -2891.939)"/></svg>
                    </button>
                </div>
                <div class="clear">
                    <button  class="clear_button" @click="clear">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13.034" height="13.593" viewBox="0 0 13.034 13.593"><path d="M-491.749,429.8l1.3-10.1h-9.528l1.3,10.1Zm-1.828-7.96a.347.347,0,0,1,.693,0v5.286a.347.347,0,0,1-.693,0v-5.286Zm-1.985,0a.347.347,0,0,1,.693,0v5.286a.347.347,0,0,1-.693,0v-5.286Zm-1.985,0a.347.347,0,0,1,.693,0v5.286a.347.347,0,0,1-.693,0v-5.286Zm4.982-4.746,1.118,1.917h2.406a.347.347,0,0,1,0,.693h-.715l-1.344,10.457a.347.347,0,0,1-.346.333h-7.54a.345.345,0,0,1-.343-.3l-1.348-10.486h-.715a.347.347,0,0,1,0-.693h2.406l1.13-1.937a.345.345,0,0,1,.3-.173h4.68a.346.346,0,0,1,.311.194Zm.317,1.917-.826-1.417h-4.283l-.826,1.417Z" transform="translate(501.733 -416.896)"/></svg>
                        すべてやり直し</button>
                </div>
            </div>
            <div class="finish">
                <!--            <button class="cancel" @click="cancel"><img src="../../assets/img/cancel.svg" alt="cancel">キャンセル</button>-->
                <button class="decide" @click="decide">
                    <span class="select_dummy_input"></span>
                    決定</button>
            </div>
        </div>
    <div class="modal_close" @click="cancel">
        <span class="round_btn"></span>
    </div>
    </div>
</template>

<script>
    import { mapMutations,mapState } from 'vuex'
    import CONST from '../../assets/js/const'

    export default {
        name: "PaintConfig",
        data: () => ({
            CONST
        }),
        computed: {
            ...mapState('paint', [
                'paint_mode',
                'paint_type',
                'brush_size'
            ]),
            ...mapState(['edit_mode'])
        },
        created() {
            this.$root.$emit('save_paint_config')
        },
        methods: {
            undo() { this.$root.$emit('undo') },
            redo() { this.$root.$emit('redo') },
            clear() { this.$root.$emit('paint_clear') },
            invert() { this.$root.$emit('paint_invert') },
            decide() {
                this.$root.$emit('set_clipping_image');
                this.setMenuMode(CONST.MENU_MODE_DEFAULT);
                this.setEditMode(CONST.EDIT_MODE_DEFAULT);
            },
            cancel() {
                this.$root.$emit('restore_paint_config');
                this.setMenuMode(CONST.MENU_MODE_DEFAULT);
                this.setEditMode(CONST.EDIT_MODE_DEFAULT);
            },
            setFreeHand(brush_size) {
                this.setPaintType(CONST.PAINT_FREE_HAND);
                this.setBrushSize(brush_size);
            },
            ...mapMutations('paint', [
                'setPaintMode',
                'setPaintType',
                'setBrushSize'
            ]),
            ...mapMutations([
                'setEditMode',
                'setClippingImage',
                "setMenuMode",
                "setEditMode"
            ])
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    button:focus{ outline: none; }
    img{ vertical-align: middle; }
.content {
    height: calc(100% - 90px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    .select_brush {
        display: flex;
        flex-direction: column;
        height: 65%;
        p {
            margin: 0;
            font-size: clamp(10px, 1vw, 16px);
        }

        button {
            margin: 0;
            padding: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            max-width: initial;
            width: calc(25% - 15px);
            height: calc(25% - 15px);
            border: none;
            background-color: #EDEDED;
            transition: 0.3s;
            cursor: pointer;

            svg {
                width: 90%;
                height: 90%;
            }

            &.selected {
                background-color: #000;

                svg {
                    fill: #fff;
                }
            }
        }

        button:hover {
            background-color: #000;

            svg {
                fill: #fff;
            }
        }
    }

    .select_brush {
        display: flex;
        justify-content: space-between;
        img {
            width: 100%;
        }

        .type, .size {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 5px 0 10px 0;
        }

        .type::before {
            content: "";
            display: block;
            width: calc(25% - 15px);
            height: calc(25% - 15px);
            order: 1;
        }

        .type::after {
            content: "";
            width: calc(25% - 15px);
            height: calc(25% - 15px);
        }

        .size {
            button:first-child {
                svg {
                    width: 50%;
                    height: 50%;
                    padding: 20%;
                }
            }

            button:nth-child(2) {
                svg {
                    padding: 10%;
                    width: 75%;
                    height: 75%;
                }
            }

            button:nth-child(3) {
                svg {
                    width: 90%;
                    height: 90%;
                }
            }
        }
    }

    .control {
        display: flex;
        justify-content: space-between;
        height: calc(35% - 10px);
        .undo_redo {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: calc(60% - 5px);
            > div {
                display: flex;
                justify-content: space-between;
                height: 50%;
                button {
                    width: calc((100% / 2) - 5px);
                    font-size: clamp(10px, 1vw, 16px);
                    margin-bottom: 10px;
                    border: 1px solid #000;
                    background-color: #fff;
                    border-radius: 3px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    transition: 0.3s;
                    cursor: pointer;
                }

                button:first-child {
                    svg {
                        margin: 0 5px 0 0;
                    }
                }

                button:last-child {
                    svg {
                        margin: 0 0 0 5px;
                    }
                }

                button:hover {
                    background-color: #000;
                    color: #fff;

                    svg {
                        fill: #fff;
                    }
                }
            }

            div.clear {
                button.clear_button {
                    max-width: initial;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: clamp(10px, 1vw, 16px);
                    border: 1px solid #000;
                    background-color: #fff;
                    border-radius: 3px;
                    cursor: pointer;
                    transition: 0.3s;
                    margin: 0;

                    svg {
                        margin: 0 5px 0 0;
                    }
                }

                button:hover {
                    background-color: #000;
                    color: #fff;

                    svg {
                        fill: #fff;
                    }
                }
            }
        }

        .finish {
            display: flex;
            justify-content: space-between;
            width: calc(40% - 5px);

            button.decide {
                margin: 0;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: clamp(10px, 1vw, 16px);
                border: 1px solid #000;
                background-color: #fff;
                border-radius: 3px;
                cursor: pointer;
                transition: 0.3s;
                .select_dummy_input::before {
                    content: "";
                    display: block;
                    position: absolute;
                    top: 40%;
                    left: 60%;
                    width: 35%;
                    height: 4px;
                    border-radius: 2px;
                    transform: translate(-6px, 5px) rotateZ(-135deg);
                    transform-origin: 2px 2px;
                    background: #FFFFFF;
                }
                .select_dummy_input::after {
                    content: "";
                    display: block;
                    position: absolute;
                    top: 40%;
                    left: 60%;
                    width: 70%;
                    height: 4px;
                    border-radius: 2px;
                    transform: translate(-6px, 5px) rotateZ(-45deg);
                    transform-origin: 2px 2px;
                    background: #FFFFFF;
                }
                .select_dummy_input {
                    position: relative;
                    top: 0;
                    left: 0;
                    display: block;
                    width: 20px;
                    height: 20px;
                    border: solid 1px #000;
                    background: #000;
                    border-radius: 50%;
                    transition: all .15s linear;
                    margin-right: 10px;
                }
                @media(max-width: 739px) {
                    .select_dummy_input::before {
                        top: 0;
                        left: 85%;
                        width: 40%;
                        height: 2px;
                        border-radius: 2px;
                        transform-origin: 2px 2px;
                    }
                    .select_dummy_input::after {
                        top: 20%;
                        left: 95%;
                        width: 80%;
                        height: 2px;
                        border-radius: 2px;
                        transform: translate(-6px, 5px) rotateZ(-45deg);
                        transform-origin: 2px 2px;
                    }
                    .select_dummy_input {
                        width: 10px;
                        height: 10px;
                        margin-right: 5px;
                    }
                }
            }

            button:hover {
                background-color: #000;
                color: #fff;
                .select_dummy_input::before {
                    background: #000;
                }
                .select_dummy_input::after {
                    background: #000;
                }
                .select_dummy_input {
                    background: #fff;
                }

            }
        }
    }
    .modal_close {
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        .round_btn {
            display: block;
            position: relative;
            width: 30px;
            height: 30px;
            border: 2px solid #343434; /* 枠の調整 */
            border-radius: 50%; /* 丸みの度合い */
            background: #fff; /* ボタンの背景色 */
            transition: 0.5s;
        }
        .round_btn::before, .round_btn::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            width: 3px; /* 棒の幅（太さ） */
            height: 22px; /* 棒の高さ */
            background: #343434; /* バツ印の色 */
        }
        .round_btn::before {
            transform: translate(-50%, -50%) rotate(45deg);
        }
        .round_btn::after {
            transform: translate(-50%, -50%) rotate(-45deg);
        }
        .round_btn:hover {
            background: #343434;
        }
        .round_btn:hover::before, .round_btn:hover::after {
            background: #fff;
        }
        @media (max-width: 739px) {
            .round_btn {
                width: 20px;
                height: 20px;
            }
            .round_btn::before, .round_btn::after {
                width: 3px; /* 棒の幅（太さ） */
                height: 15px; /* 棒の高さ */
            }
        }
    }
}
@media screen and (max-width:799px) {
    .content {
        height: calc(100% - 80px);

        .select_brush {
            display: flex;
            flex-direction: column;

            p {
                margin: 0;
                font-size: clamp(10px, 1vw, 16px);
            }

            button {
                margin: 0;
                padding: 5px;
                width: calc(22% - 15px);
                height: calc(22% - 15px);

                svg {
                    width: 80%;
                    height: 80%;
                }
            }
        }

        .control {
            .undo_redo {
                width: 60%;

                > div {
                    button {
                        margin-bottom: 5px;
                        width: calc((100% / 2) - 2.5px);
                    }

                }
            }
        }

        .select_brush {
            .type, .size {
                margin: 5px 0;
            }

            .type::before {
                width: calc(22% - 15px);
                height: calc(22% - 15px);
            }

            .type::after {
                content: "";
                width: calc(22% - 15px);
                height: calc(22% - 15px);
            }

            .size {
                button:first-child {
                    svg {
                        width: 50%;
                        height: 50%;
                        padding: 20%;
                    }
                }

                button:nth-child(2) {
                    svg {
                        padding: 10%;
                        width: 75%;
                        height: 75%;
                    }
                }

                button:nth-child(3) {
                    svg {
                        width: 90%;
                        height: 90%;
                    }
                }
            }
        }
    }
}
</style>
